import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabaseClient'
import { useToast } from '../components/useToast' 
import { useCurrency } from '../hooks/useCurrency'
import { useLanguage } from '../hooks/useLanguage'
import { Capacitor } from '@capacitor/core'
import { useAuth } from '../context/AuthContext'
import ActivarDeteccionBancos from '../components/ActivarDeteccionBancos'
import { SPECIAL_THEMES } from '../lib/themesConfig'


export default function Perfil() {

  const { isPremium, trialActive, diasRestantes, subscriptionExpiresAt } = useAuth()
  const { t } = useLanguage()
  const navigate = useNavigate()
  const toast = useToast() 

  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [unlockedTheme, setUnlockedTheme] = useState(null)

  const [displayName, setDisplayName] = useState('')
  const [email, setEmail] = useState('')
  const [friendId, setFriendId] = useState('')
  const [photoUrl, setPhotoUrl] = useState('')
  const [showDeleteOverlay, setShowDeleteOverlay] = useState(false)
  const [saving, setSaving] = useState(false)
  const [editingEmail, setEditingEmail] = useState(false)
  const [showConfirmGenerateId, setShowConfirmGenerateId] = useState(false)

  // SESIONES
  const [activeSessions, setActiveSessions] = useState([])
  const [loadingSessions, setLoadingSessions] = useState(false)
  const [currentToken, setCurrentToken] = useState(null)
  const [showConfirmCloseSessions, setShowConfirmCloseSessions] = useState(false)
  // Temas
  const [themeCode, setThemeCode] = useState('')
  const [loadingCode, setLoadingCode] = useState(false)
  const [userThemes, setUserThemes] = useState([])
  //vista
  const [vistaGeneral, setVistaGeneral] = useState(false)
  //Currency
  const { currency, rates, lastUpdated } = useCurrency()



  const currencies = [
  { id: 'COP', name: 'Peso colombiano', flag: '🇨🇴', symbol: '$', locale: 'es-CO' },
  { id: 'USD', name: 'Dólar estadounidense', flag: '🇺🇸', symbol: '$', locale: 'en-US' },
  { id: 'CAD', name: 'Dólar canadiense', flag: '🇨🇦', symbol: '$', locale: 'en-CA' },
  ]

  const [selectedCurrency, setSelectedCurrency] = useState(
    localStorage.getItem('app-currency') || 'COP'
  )

  const languages = [
  { id: 'es', name: 'Español', flag: '🇪🇸' },
  { id: 'en', name: 'English', flag: '🇺🇸' },
  { id: 'fr', name: 'Français', flag: '🇫🇷' },
]

const [selectedLanguage, setSelectedLanguage] = useState(
  localStorage.getItem('app-language') || 'es'
)

  function changeCurrency(currencyId) {
    localStorage.setItem('app-currency', currencyId)
    window.dispatchEvent(new CustomEvent('currencyChange', { detail: currencyId }))
    setSelectedCurrency(currencyId)
  }
  // themes
  const themes = [
    {
      id: 'dark',
      name: '🌑 Oscuro',
      background: '#0f0f10',
      card: '#17181c',
      accent: '#000000',
      label: '#9ca3af'
    },
    {
      id: 'white',
      name: '☀️ Blanco',
      background: '#f3f4f6',
      card: '#d7d7d7',
      accent: '#fdfdfd',
      label: '#6b7280'
    },
    {
      id: 'purple',
      name: '💜 Morado',
      background: '#390f66dc',
      card: '#6b0dd096',
      accent: '#8b5cf6',
      label: '#a89fd4'
    },
    {
      id: 'green',
      name: '🔷 Azul',
      background: '#040329',
      card: '#150b4ca3',
      accent: '#4134d3',
      label: '#8696ef'
    },
  ]

  const [selectedTheme, setSelectedTheme] = useState(
    localStorage.getItem('app-theme') || 'dark'
  )

  function changeTheme(theme) {
    localStorage.setItem('app-theme', theme)
    document.documentElement.setAttribute('data-theme', theme)
    setSelectedTheme(theme)
  }

function tiempoDesdeActualizacion() {
  if (!lastUpdated) return t('actualizacion_nunca')
  const mins = Math.floor((Date.now() - lastUpdated) / 60000)
  if (mins < 1) return t('actualizacion_menos_1_min')
  if (mins < 60) return t('actualizacion_minutos').replace('{n}', mins)
  const hrs = Math.floor(mins / 60)
  return t('actualizacion_horas').replace('{n}', hrs)
}

  function equivalencias() {
    if (!rates || currency === 'COP') return null
    if (currency === 'CAD') {
      const aCAD = (1 / rates.CAD).toFixed(0)
      const cadAUSD = (rates.USD / rates.CAD).toFixed(4)
      return `1 CAD = $${Number(aCAD).toLocaleString('es-CO')} COP · ${cadAUSD} USD`
    }
    if (currency === 'USD') {
      const aUSD = (1 / rates.USD).toFixed(0)
      const usdACAD = (rates.CAD / rates.USD).toFixed(4)
      return `1 USD = $${Number(aUSD).toLocaleString('es-CO')} COP · ${usdACAD} CAD`
    }
  }

  useEffect(() => {
    async function loadUser() {
      const { data } = await supabase.auth.getUser()
      if (!data.user) { navigate('/login'); return }

      setUser(data.user)
      setEmail(data.user.email || '')
      setDisplayName(data.user.user_metadata?.display_name || data.user.user_metadata?.full_name || '')
      setPhotoUrl(data.user.user_metadata?.avatar_url || '')
      setFriendId(data.user.user_metadata?.friend_id || '')

      // TOKEN ACTUAL
      const token = localStorage.getItem('session_token_' + data.user.id)
      setCurrentToken(token)

    const { data: profile } = await supabase
      .from('profiles')
      .select('currency, themes, selected_theme, vista_general, language')
      .eq('id', data.user.id)
      .single()

      setUserThemes(profile?.themes || [])

      if (profile?.currency) {
        setSelectedCurrency(profile.currency)
        localStorage.setItem('app-currency', profile.currency)
      }
          if (profile?.selected_theme) {
      setSelectedTheme(profile.selected_theme)

      localStorage.setItem(
        'app-theme',
        profile.selected_theme
      )

      document.documentElement.setAttribute(
        'data-theme',
        profile.selected_theme
      )
    }

        if (profile?.vista_general !== undefined) {
        setVistaGeneral(profile.vista_general)
        localStorage.setItem('app-vista-general', profile.vista_general ? 'true' : 'false')
      }if (profile?.language) {
      setSelectedLanguage(profile.language)
      localStorage.setItem('app-language', profile.language)
    }
    // Consultar suscripción activa

      setLoading(false)

      // CARGAR SESIONES
      await loadSessions(data.user.id)
    }
    loadUser()
    // eslint-disable-next-line
  }, [navigate])

  async function loadSessions(userId) {
    const uid = userId || user?.id
    if (!uid) return
    setLoadingSessions(true)
    const { data } = await supabase
      .from('active_sessions')
      .select('*')
      .eq('user_id', uid)
      .order('last_seen', { ascending: false })
    setActiveSessions(data || [])
    setLoadingSessions(false)
  }

  async function closeSession(token) {
    await supabase
      .from('active_sessions')
      .delete()
      .eq('session_token', token)
      .eq('user_id', user.id)
    loadSessions()
  }

function handleCloseAllOtherSessionsClick() {
    setShowConfirmCloseSessions(true)
  }

  async function closeAllOtherSessions() {
    setShowConfirmCloseSessions(false)
    await supabase
      .from('active_sessions')
      .delete()
      .eq('user_id', user.id)
      .neq('session_token', currentToken)
    loadSessions()
    toast.success('Sesiones cerradas correctamente')
  }

  async function handlePhotoChange(e) {
    const file = e.target.files[0]
    if (!file || !user) return
    if (file.size > 2 * 1024 * 1024) { toast.warning('La imagen no puede pesar más de 2MB'); return }
    try {
      const fileExt = file.name.split('.').pop()
      const fileName = `${user.id}.${fileExt}`
      const { error: uploadError } = await supabase.storage.from('avatars').upload(fileName, file, { cacheControl: '3600', upsert: true })
      if (uploadError) { console.error(uploadError); toast.error(uploadError.message); return }
      const { data: { publicUrl } } = supabase.storage.from('avatars').getPublicUrl(fileName)
      setPhotoUrl(publicUrl)
      await supabase.auth.updateUser({ data: { avatar_url: publicUrl } })
      const { error: profileError } = await supabase.from('profiles').update({ avatar_path: fileName }).eq('id', user.id)
      if (profileError) { console.error(profileError); toast.error('Imagen subida pero no se pudo guardar en profiles') }
    } catch (err) { console.error(err); toast.error('Error subiendo imagen') }
  }

  async function handleDeletePhoto() {
    if (!user || !photoUrl) return
    try {
      const fileName = photoUrl.split('/').pop().split('?')[0]
      const { error } = await supabase.storage.from('avatars').remove([fileName])
      if (error) console.error(error)
      await supabase.auth.updateUser({ data: { avatar_url: '' } })
      setPhotoUrl('')
      setShowDeleteOverlay(false)
    } catch (err) { console.error(err); toast.error('Error eliminando foto') }
  }

  function generateFriendId(length = 12) {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
    let result = ''
    for (let i = 0; i < length; i++) result += chars.charAt(Math.floor(Math.random() * chars.length))
    return result
  }

function handleGenerateIdClick() {
    setShowConfirmGenerateId(true)
  }

  async function confirmarGenerateId() {
    setShowConfirmGenerateId(false)
    try {
      const newId = generateFriendId()
      const { error } = await supabase.auth.updateUser({ data: { friend_id: newId } })
      if (error) { console.error(error); toast.error('Error generando ID'); return }
      setFriendId(newId)
      const { error: profileError } = await supabase.from('profiles').update({ friend_id: newId }).eq('id', user.id)
      if (profileError) { console.error(profileError); toast.error('ID generado pero no se pudo guardar en profiles'); return }
      toast.success('ID generado correctamente')
    } catch (err) { console.error(err); toast.error('Ocurrió un error') }
  }
  async function redeemThemeCode() {
  const code = themeCode.trim().toUpperCase()

  if (!code) {
    toast.warning('Ingresa un Código')
    return
  }

  setLoadingCode(true)

  try {
    const themeMap = Object.fromEntries(
      Object.values(SPECIAL_THEMES).map(c => [c.code, c.id])
    )

    const theme = themeMap[code]

    if (!theme) {
      toast.error('Código inválido', 'El código que ingresaste no existe o ya expiró.')
      return
    }

    const { data: profile, error: profileError } = await supabase
      .from('profiles')
      .select('themes')
      .eq('id', user.id)
      .single()

    if (profileError) throw profileError

    const themes = profile?.themes || []

    if (themes.includes(theme)) {
      toast.warning('Ya desbloqueado', 'Este tema ya estaba en tu cuenta.')
      return
    }

    const { error } = await supabase
      .from('profiles')
      .update({
        themes: [...themes, theme]
      })
      .eq('id', user.id)

    if (error) throw error

    setUserThemes([...themes, theme])

    setUnlockedTheme(theme) // 'worldcup'

    toast.success(
      t('tema_toast_desbloqueado'),
      t('tema_toast_desbloqueado_desc').replace('{tema}', t(SPECIAL_THEMES[theme].keys.name))
    )

    setThemeCode('')

  } catch (err) {
    console.error(err)
    toast.warning('Error al canjear el codigo')
  } finally {
    setLoadingCode(false)
  }
}

const cfgUnlocked = unlockedTheme ? SPECIAL_THEMES[unlockedTheme] : null

async function handleSave() {
  if (displayName.trim().length > 50) {
    toast.error('El nombre no puede tener más de 50 caracteres')
    return
  }

  try {
    setSaving(true)
    const emailChanged = email !== user.email

    // Actualizar datos del usuario
    const { error } = await supabase.auth.updateUser({
      data: { display_name: displayName, avatar_url: photoUrl },
      ...(emailChanged ? { email } : {})
    })

    // Si hay error pero es por el cambio de email pendiente de confirmación, no es un fallo real
    if (error) {
      const esErrorDeEmail =
        error.message?.toLowerCase().includes('email') ||
        error.message?.toLowerCase().includes('confirmation')

      if (!esErrorDeEmail) {
        toast.error('Error', 'No se pudieron guardar los cambios.')
        return
      }
      // Si es error de email, continuamos igual — el correo de confirmación ya se envió
    }

    // Actualizar perfil en la tabla profiles
    const fileName = photoUrl ? photoUrl.split('/').pop().split('?')[0] : null
    const { error: profileError } = await supabase
      .from('profiles')
      .update({
        full_name: displayName,
        avatar_path: fileName,
        currency: selectedCurrency,
        selected_theme: selectedTheme,
        vista_general: vistaGeneral,
        language: selectedLanguage,
      })
      .eq('id', user.id)

    if (profileError) {
      console.error(profileError)
      toast.error('Error', 'No se pudo actualizar el perfil.')
      return
    }

    // Al final del try en handleSave, antes del toast.success:
    localStorage.setItem('app-vista-general', vistaGeneral ? 'true' : 'false')
    window.dispatchEvent(new CustomEvent('vistaChange', { detail: vistaGeneral }))
    localStorage.setItem('app-language', selectedLanguage)
      window.dispatchEvent(new CustomEvent('languageChange', { detail: selectedLanguage }))

    if (emailChanged) {
      toast.success('Correo en proceso', 'Revisa tu correo actual y el nuevo para confirmar el cambio.')
      // Revertir el input al email actual hasta que confirme
      setEmail(user.email)
      setEditingEmail(false)
    } else {
      toast.success('Perfil actualizado', 'Tus cambios se guardaron correctamente.')
    }

  } catch (err) {
    console.error(err)
    toast.error('Error', 'Ocurrió un error inesperado.')
  } finally {
    setSaving(false)
  }
}

function handleSuscribirse() {
  // Antes abríamos el navegador externo en Android con Browser.open, pero eso
  // sacaba a la app del contexto nativo de Capacitor: al cargar Suscripcion.jsx
  // en un navegador externo, Capacitor.isNativePlatform() detecta false y cae
  // al flujo de Wompi en vez del flujo nativo de RevenueCat/Google Play Billing.
  // Ahora que la compra nativa ya funciona, siempre navegamos dentro de la app.
  navigate('/Suscripcion')
}

  function timeAgo(iso) {
    const diff = Date.now() - new Date(iso).getTime()
    const mins = Math.floor(diff / 60000)
    if (mins < 1) return t('tiempo_ahora')
    if (mins < 60) return t('tiempo_min').replace('{n}', mins)
    const hrs = Math.floor(mins / 60)
    if (hrs < 24) return t('tiempo_hora').replace('{n}', hrs)
    return t('tiempo_dia').replace('{n}', Math.floor(hrs / 24))
  }

if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 20, background: 'var(--color-bg)' }}>
        <div style={{ width: 70, height: 70, borderRadius: 20, background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32, animation: 'pulse 1.5s infinite' }}>🧑‍💻</div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--color-text)', marginBottom: 6 }}>{t('perfil_loading_titulo')}</div>
          <div style={{ fontSize: 14, color: 'var(--color-muted)' }}>{t('perfil_loading_desc')}</div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {[0, 1, 2].map(i => (
            <div key={i} style={{ width: 10, height: 10, borderRadius: '50%', background: '#6366f1', animation: `bounce 0.6s infinite ${i * 0.15}s` }} />
          ))}
        </div>
        <style>{`
          @keyframes pulse { 0%,100%{transform:scale(1);opacity:1} 50%{transform:scale(1.08);opacity:0.85} }
          @keyframes bounce { 0%,80%,100%{transform:translateY(0);opacity:0.5} 40%{transform:translateY(-8px);opacity:1} }
        `}</style>
      </div>
    )
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-bg)' }}>

      {/* HEADER */}
      <header style={{ background: 'var(--color-surface)', borderBottom: '1px solid var(--color-border)', padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button
            onClick={() => navigate('/home')}
            style={{ width: 36, height: 36, background: 'rgba(120,120,120,0.08)', border: '1px solid var(--color-border)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 18, color: 'var(--color-text)', transition: '0.2s' }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateX(-2px)'; e.currentTarget.style.borderColor = 'var(--color-primary)' }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.borderColor = 'var(--color-border)' }}
          >←</button>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--color-text)' }}>{t('perfil_titulo')}</div>
            <div style={{ fontSize: 12, color: 'var(--color-muted)' }}>{t('perfil_subtitulo')}</div>
          </div>
        </div>
      </header>
      

      <main style={{ maxWidth: 700, margin: '0 auto', padding: '24px 16px' }}>

{cfgUnlocked && (
  <div className="unlock-overlay" onClick={() => setUnlockedTheme(null)}>
    <div
      className={`unlock-card unlock-card--${cfgUnlocked.id}`}
      onClick={e => e.stopPropagation()}
    >
      <div className="unlock-ring" />
      <span className="unlock-badge">{t('tema_badge_desbloqueado')}</span>
      <span className="unlock-emoji">{cfgUnlocked.emoji}</span>
      <div className="unlock-title">{t(cfgUnlocked.keys.name)}</div>
      <div className="unlock-sub">{t(cfgUnlocked.keys.desc)}</div>
      <div className="unlock-actions">
        <button
          className="unlock-btn-primary"
          onClick={() => { changeTheme(cfgUnlocked.id); setUnlockedTheme(null) }}
        >
          {t('tema_aplicar')}
        </button>
        <button className="unlock-btn-secondary" onClick={() => setUnlockedTheme(null)}>
          {t('unlock_ahora_no')}
        </button>
      </div>
    </div>
  </div>
)}

        {/* FOTO */}
        <section style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 24, padding: 24, marginBottom: 22 }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <div
              onMouseEnter={() => setShowDeleteOverlay(true)}
              onMouseLeave={() => setShowDeleteOverlay(false)}
              style={{ width: 120, height: 120, borderRadius: '50%', overflow: 'hidden', background: 'var(--color-primary-lt)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 18, border: '4px solid rgba(255,255,255,0.06)', position: 'relative', cursor: photoUrl ? 'pointer' : 'default' }}
            >
              {photoUrl ? (
                <>
                  <img src={photoUrl} alt="avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  <div onClick={handleDeletePhoto} style={{ position: 'absolute', inset: 0, background: showDeleteOverlay ? 'rgba(239,68,68,0.65)' : 'transparent', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 700, fontSize: 14, opacity: showDeleteOverlay ? 1 : 0, transition: '0.25s ease' }}>
                    <div style={{ fontSize: 30, marginBottom: 4 }}>🗑️</div>
                    Eliminar
                  </div>
                </>
              ) : (
                <span style={{ fontSize: 42, fontWeight: 700, color: 'var(--color-primary)' }}>
                  {displayName.charAt(0).toUpperCase()}
                </span>
              )}
            </div>
            <label style={{ padding: '10px 16px', borderRadius: 12, background: 'var(--color-primary)', color: 'var(--color-text)', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
              {t('cambiar_foto')}
              <input type="file" accept="image/png, image/jpeg, image/webp" style={{ display: 'none' }} onChange={handlePhotoChange} />
            </label>
          </div>
        </section>

        {/* SUSCRIPCIÓN */}
      <button
        onClick={handleSuscribirse} 
        style={{
          width: '100%',
          padding: '20px 22px',
          borderRadius: 24,
          border: isPremium
            ? '1px solid rgba(34,197,94,0.4)'
            : '1px solid color-mix(in srgb, var(--color-primary) 40%, transparent)',
          background: isPremium
            ? 'linear-gradient(135deg,#16a34a,#22c55e)'
            : trialActive
              ? 'linear-gradient(135deg,#f59e0b,#d97706)' // ámbar mientras está en trial
              : 'linear-gradient(135deg,var(--stat-saving-1),var(--stat-saving-2))',
          color: 'white',
          cursor: 'pointer',
          marginBottom: 22,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 14,
          textAlign: 'left',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: 'var(--shadow-card)',
          transition: 'transform 0.18s ease, box-shadow 0.18s ease',
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.3)' }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'var(--shadow-card)' }}
      >
        <div style={{ position: 'absolute', top: -30, right: -30, width: 110, height: 110, borderRadius: '50%', background: 'rgba(255,255,255,0.1)' }} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{
            width: 46, height: 46, borderRadius: 14,
            background: 'rgba(255,255,255,0.15)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 22, flexShrink: 0,
          }}>
            {isPremium ? '✅' : '⭐'}
          </div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8 }}>
              {t('suscripcion_plan_nombre')}
              {isPremium && (
                <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 999, background: 'rgba(255,255,255,0.2)' }}>
                  {t('suscripcion_activa_badge')}
                </span>
              )}
            </div>
            <div style={{ fontSize: 12, opacity: 0.85, marginTop: 2 }}>
            {isPremium
              ? `${t('suscripcion_vence_pre')} ${new Date(subscriptionExpiresAt).toLocaleDateString('es-CO')}`
              : trialActive
                ? `${t('suscripcion_trial_activa')} ${diasRestantes} ${diasRestantes === 1 ? t('dia_singular') : t('dias_plural')}`
                : t('suscripcion_trial_vencida')}
            </div>
          </div>
        </div>

        <span style={{ fontSize: 16, opacity: 0.9, flexShrink: 0 }}>→</span>
      </button>

       {/* IDIOMA */}
      <section style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 24, padding: 22, marginBottom: 22 }}>
        <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6, color: 'var(--color-text)' }}>{t('idioma_titulo')}</div>
        <div style={{ fontSize: 13, color: 'var(--color-muted)', marginBottom: 18, lineHeight: 1.5 }}>
          {t('idioma_desc')}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
          {languages.map(l => (
            <button
              key={l.id}
              onClick={() => setSelectedLanguage(l.id)}
              style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8,
                padding: '14px 10px', borderRadius: 14, cursor: 'pointer',
                background: selectedLanguage === l.id ? 'rgba(59,130,246,0.08)' : 'var(--color-bg)',
                border: selectedLanguage === l.id ? '2px solid #3b82f6' : '1px solid var(--color-border)',
                transition: '0.2s', position: 'relative'
              }}
            >
              {selectedLanguage === l.id && (
                <span style={{ position: 'absolute', top: 6, right: 6, fontSize: 10, fontWeight: 700, padding: '2px 6px', borderRadius: 999, background: 'rgba(59,130,246,0.15)', color: '#3b82f6' }}>
                  {t('activo')}
                </span>
              )}
              <span style={{ fontSize: 30 }}>{l.flag}</span>
              <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--color-text)', textAlign: 'center' }}>{l.name}</span>
            </button>
          ))}
        </div>
      </section>

      {/* Codigo */}
        <section
        style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)',
          borderRadius: 20,
          padding: 16,
          marginTop: 20
        }}
      >
        <h3 style={{ marginBottom: 12 }}>
          {t('canjear_codigo')}
        </h3>

        <input
          type="text"
          value={themeCode}
          onChange={(e) => setThemeCode(e.target.value.toUpperCase())}
          placeholder={t('canjear_placeholder')}
          style={{
            width: '100%',
            padding: '14px 16px',
            borderRadius: 14,
            border: '1px solid rgba(34,197,94,0.25)',
            background: 'var(--color-bg)',
            color: 'var(--color-text)',
            outline: 'none',
            fontSize: 14,
            fontWeight: 700,
            letterSpacing: 2,
            textTransform: 'uppercase',
            boxSizing: 'border-box',
            marginBottom: 12,
            boxShadow: '0 0 0 1px rgba(34,197,94,0.05)'
          }}
        />

        <button
          onClick={redeemThemeCode}
          disabled={loadingCode}
          style={{
            width: '100%',
            padding: 12,
            border: 'none',
            borderRadius: 12,
            background: '#22c55e',
            color: '#fff',
            fontWeight: 700,
            cursor: 'pointer'
          }}
        >
          {loadingCode ? t('canjear_validando') : t('canjear_boton')}
        </button>
      </section>
<br />
        {/* ID DE AMIGOS */}
        <section style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 24, padding: 22, marginBottom: 22 }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6, color: 'var(--color-text)' }}>{t('id_amigo_titulo')}</div>
          <div style={{ fontSize: 13, color: 'var(--color-muted)', marginBottom: 18, lineHeight: 1.5 }}>{t('id_amigo_desc')}</div>
          <div style={{ display: 'flex', gap: 12, flexDirection: window.innerWidth < 600 ? 'column' : 'row' }}>
            <div style={{ flex: 1, padding: '14px 16px', borderRadius: 14, border: '1px solid var(--color-border)', background: 'var(--color-bg)', color: friendId ? 'var(--color-text)' : 'var(--color-muted)', fontSize: 15, fontWeight: 700, letterSpacing: 2, overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {friendId || t('no_generado')}
            </div>
            <button onClick={handleGenerateIdClick} style={{ padding: '14px 18px', borderRadius: 14, border: 'none', background: 'linear-gradient(135deg,#3b82f6,#2563eb)', color: 'white', fontWeight: 700, cursor: 'pointer' }}>
              {friendId ? t('regenerar') : t('generar')}
            </button>
          </div>
        </section>

        {/* CORREO */}
        <section style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 24, padding: 22, marginBottom: 22 }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6, color: 'var(--color-text)' }}>{t('correo_titulo')}</div>
          <div style={{ fontSize: 13, color: 'var(--color-muted)', marginBottom: 16, lineHeight: 1.5 }}>{t('correo_desc')}</div>
          <div style={{ display: 'flex', gap: 12, flexDirection: window.innerWidth < 600 ? 'column' : 'row' }}>
            <button
              onClick={() => setEditingEmail(!editingEmail)}
              style={{ padding: '14px 18px', borderRadius: 14, border: 'none', background: editingEmail ? '#ef4444' : 'linear-gradient(135deg,#f59e0b,#d97706)', color: 'white', fontWeight: 700, cursor: 'pointer', minWidth: 120 }}
            >
              {editingEmail ? t('bloquear') : t('editar')}
            </button>
            <input type="email" value={email} disabled={!editingEmail} onChange={e => setEmail(e.target.value)} placeholder="correo@ejemplo.com"
              style={{ flex: 1, padding: '14px 16px', borderRadius: 14, border: '1px solid var(--color-border)', background: editingEmail ? 'var(--color-bg)' : 'rgba(120,120,120,0.08)', color: editingEmail ? 'var(--color-text)' : '#888', outline: 'none', fontSize: 14, boxSizing: 'border-box', cursor: editingEmail ? 'text' : 'not-allowed', opacity: editingEmail ? 1 : 0.8 }}
            />
          </div>
        </section>

        {/* NOMBRE */}
        <section style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 24, padding: 22, marginBottom: 22 }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6, color: 'var(--color-text)' }}>{t('nombre_titulo')}</div>
          <div style={{ fontSize: 13, color: 'var(--color-muted)', marginBottom: 16 }}>{t('nombre_desc')}</div>
          <input type="text" value={displayName} onChange={e => setDisplayName(e.target.value)} placeholder={t('nombre_placeholder')}
            style={{ width: '100%', padding: '14px 16px', borderRadius: 14, border: '1px solid var(--color-border)', background: 'var(--color-bg)', color: 'var(--color-text)', outline: 'none', fontSize: 14, boxSizing: 'border-box' }}
          />
        </section>

        {/* VISTA PREFERIDA */}
      <section style={{
        background: 'var(--color-surface)',
        border: '1px solid var(--color-border)',
        borderRadius: 24,
        padding: 22,
        marginBottom: 22
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 16
        }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 4, color: 'var(--color-text)' }}>
              {t('vista_titulo')}
            </div>
            <div style={{ fontSize: 13, color: 'var(--color-muted)', lineHeight: 1.5 }}>
              {t('vista_desc_pre')} <strong style={{ color: 'var(--color-text)' }}>{t('vista_mensual')}</strong> o <strong style={{ color: 'var(--color-text)' }}>{t('vista_general')}</strong>.
            </div>
            <div style={{
              marginTop: 8,
              fontSize: 12,
              fontWeight: 700,
              color: vistaGeneral ? '#22c55e' : '#6b7280'
            }}>
              {vistaGeneral ? t('vista_general_activa') : t('vista_mensual_activa')}
            </div>
          </div>

          {/* Toggle estilo iPhone */}
          <button
            type="button"
            role="switch"
            aria-checked={vistaGeneral}
            onClick={() => setVistaGeneral(v => !v)}
            style={{
              width: 51,
              height: 31,
              borderRadius: 999,
              background: vistaGeneral ? '#22c55e' : '#3a3a3c',
              position: 'relative',
              cursor: 'pointer',
              transition: 'background 0.25s ease',
              flexShrink: 0,
              border: 'none',
              padding: 0,
              boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.15)',
            }}
          >
            <div style={{
              position: 'absolute',
              top: 2,
              left: vistaGeneral ? 22 : 2,
              width: 27,
              height: 27,
              borderRadius: '50%',
              background: 'white',
              boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
              transition: 'left 0.25s cubic-bezier(0.34,1.56,0.64,1)',
            }} />
          </button>
        </div>
      </section>

        {/* PALETA DE COLORES */}
        <section style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 24, padding: 22, marginBottom: 22 }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6, color: 'var(--color-text)' }}>{t('color_titulo')}</div>
          <div style={{ fontSize: 13, color: 'var(--color-muted)', marginBottom: 18 }}>{t('color_desc')}</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12 }}>
            {themes.map(theme => (
              <button key={theme.id} onClick={() => changeTheme(theme.id)}
                style={{
                  background: theme.background,
                  border: selectedTheme === theme.id ? `2px solid ${theme.accent}` : '1px solid rgba(255,255,255,0.08)',
                  borderRadius: 18,
                  padding: 16,
                  cursor: 'pointer',
                  transition: '0.2s',
                  textAlign: 'left',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                {/* GLOW DE FONDO */}
                <div style={{ position: 'absolute', top: -20, right: -20, width: 80, height: 80, borderRadius: '50%', background: theme.accent, opacity: 0.12, filter: 'blur(20px)' }} />

                {/* PREVIEW CHIPS */}
                <div style={{ display: 'flex', gap: 6, marginBottom: 12 }}>
                  <div style={{ width: 28, height: 28, borderRadius: 8, background: theme.card, border: '1px solid rgba(255,255,255,0.06)' }} />
                  <div style={{ width: 28, height: 28, borderRadius: 8, background: theme.accent }} />
                  <div style={{ width: 28, height: 28, borderRadius: 8, background: theme.card, border: `1px solid ${theme.accent}33` }} />
                </div>

                <div style={{ fontSize: 13, fontWeight: 700, color: 'white', marginBottom: 2, textShadow: theme.id === 'white' ? '0 1px 2px rgba(0,0,0,0.4)' : 'none' }}>{theme.name}</div>
                  <div style={{ fontSize: 10, color: theme.label,
                    textShadow: theme.id === 'white' ? '0 1px 2px rgba(0,0,0,0.3)' : 'none'
                  }}>
                    {selectedTheme === theme.id ? t('activo') : t('toca_aplicar')}
                  </div>
              </button>
            ))}
          </div>
        </section>

        {/* TEMAS */}
        <section
          style={{
            background: 'var(--color-surface)',
            border: '1px solid var(--color-border)',
            borderRadius: 24,
            padding: 22,
            marginBottom: 22
          }}
        >
          <div
            style={{
              fontSize: 16,
              fontWeight: 700,
              marginBottom: 6,
              color: 'var(--color-text)'
            }}
          >
            {t('temas_titulo')}
          </div>

          <div
            style={{
              fontSize: 13,
              color: 'var(--color-muted)',
              marginBottom: 18
            }}
          >
            {t('temas_desc')}
          </div>

          {userThemes.some(id => SPECIAL_THEMES[id]) ? (
          <div style={{ display: 'grid', gap: 12 }}>
            {userThemes.filter(id => SPECIAL_THEMES[id]).map(id => {
              const c = SPECIAL_THEMES[id]
              const active = selectedTheme === id
              return (
                <button
                  key={id}
                  onClick={() => changeTheme(id)}
                  style={{
                    width: '100%', padding: 18, borderRadius: 18,
                    border: active ? `2px solid ${c.accent}` : '1px solid var(--color-border)',
                    background: c.bg,
                    boxShadow: active ? `0 0 25px ${c.glow}` : 'none',
                    cursor: 'pointer', textAlign: 'left',
                    position: 'relative', overflow: 'hidden'
                  }}
                >
                  <div style={{ position: 'absolute', top: -30, right: -30, width: 120, height: 120, borderRadius: '50%', background: c.accent, opacity: 0.15, filter: 'blur(30px)' }} />
                  <div style={{ fontSize: 28, marginBottom: 8, animation: 'trophyFloat 3s ease-in-out infinite' }}>
                    {c.preview}
                  </div>
                  <div style={{ color: 'white', fontWeight: 700, fontSize: 15 }}>{t(c.keys.name)}</div>
                  <div style={{ color: '#cbd5e1', fontSize: 12, marginTop: 4 }}>{t(c.keys.desc)}</div>
                  {active && (
                    <span style={{ position: 'absolute', top: 12, right: 12, fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 999, background: 'rgba(255,255,255,0.15)', color: 'white' }}>
                      {t('activo')}
                    </span>
                  )}
                </button>
              )
            })}
          </div>
        ) : (
          <div style={{ fontSize: 13, color: 'var(--color-muted)', textAlign: 'center', padding: 16 }}>
            {t('sin_temas')}
          </div>
        )}
        </section>

        {/* DIVISA */}
        <section style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 24, padding: 22, marginBottom: 22 }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6, color: 'var(--color-text)' }}>{t('moneda_titulo')}</div>
          <div style={{ fontSize: 13, color: 'var(--color-muted)', marginBottom: 18, lineHeight: 1.5 }}>
            {t('moneda_desc')}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
            {currencies.map(c => (
              <button
                key={c.id}
                onClick={() => changeCurrency(c.id)}
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8,
                  padding: '14px 10px', borderRadius: 14, cursor: 'pointer',
                  background: selectedCurrency === c.id ? 'rgba(59,130,246,0.08)' : 'var(--color-bg)',
                  border: selectedCurrency === c.id ? '2px solid #3b82f6' : '1px solid var(--color-border)',
                  transition: '0.2s', position: 'relative'
                }}
              >
                {selectedCurrency === c.id && (
                  <span style={{ position: 'absolute', top: 6, right: 6, fontSize: 10, fontWeight: 700, padding: '2px 6px', borderRadius: 999, background: 'rgba(59,130,246,0.15)', color: '#3b82f6' }}>
                    {t('activo')}
                  </span>
                )}
                <span style={{ fontSize: 30 }}>{c.flag}</span>
                <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--color-text)', textAlign: 'center' }}>{c.name}</span>
                <span style={{ fontSize: 11, color: 'var(--color-muted)' }}>{c.id} · {c.symbol}</span>
              </button>
              
            ))}
          </div>
          <div style={{
            marginTop: 8,
            fontSize: 11,
            color: 'var(--color-muted)',
            display: 'flex',
            flexDirection: 'column',
            gap: 4
          }}>
            {equivalencias() && (
              <span style={{
                color: 'var(--color-text)',
                fontWeight: 600,
                fontSize: 12
              }}>
                💱 {equivalencias()}
              </span>
            )}
          </div>
          <div style={{
            fontSize: 12,
            color: 'var(--color-muted)',
            background: 'rgba(245,158,11,0.08)',
            border: '1px solid rgba(245,158,11,0.25)',
            borderRadius: 8,
            padding: '8px 10px',
            marginTop: 6,
            lineHeight: 1.5
          }}>
            {t('moneda_aviso')}
          </div>
        <br />
        <span style={{ whiteSpace: 'nowrap', fontSize: 11 }}>
  🕐 Última actualización de la Tasa de cambio: {tiempoDesdeActualizacion()}
</span>
        </section>

        <ActivarDeteccionBancos />

        {/* ── SESIONES ACTIVAS ── */}
        <section style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 24, padding: 22, marginBottom: 22 }}>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
            <div>
              <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--color-text)', marginBottom: 4 }}>{t('sesiones_titulo')}</div>
              <div style={{ fontSize: 13, color: 'var(--color-muted)', lineHeight: 1.5 }}>
                {t('sesiones_desc')}
              </div>
            </div>
            <button
              onClick={() => loadSessions()}
              style={{ background: 'none', border: 'none', color: 'var(--color-muted)', cursor: 'pointer', fontSize: 18, padding: 4, flexShrink: 0 }}
              title={t('recargar_sesiones')}
            >🔄</button>
          </div>

          {loadingSessions ? (
            <div style={{ fontSize: 13, color: 'var(--color-muted)', textAlign: 'center', padding: 20 }}>{t('cargando_sesiones')}</div>
          ) : activeSessions.length === 0 ? (
            <div style={{ fontSize: 13, color: 'var(--color-muted)', textAlign: 'center', padding: 20 }}>{t('sin_sesiones')}</div>
          ) : (
            <>
              {activeSessions.map(s => {
                const isCurrent = s.session_token === currentToken
                return (
                  <div key={s.id} style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '12px 14px', borderRadius: 14, marginBottom: 10,
                    background: isCurrent ? 'rgba(34,197,94,0.06)' : 'var(--color-bg)',
                    border: isCurrent ? '1px solid rgba(34,197,94,0.25)' : '1px solid var(--color-border)'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <div style={{ fontSize: 26, flexShrink: 0 }}>
                        {s.device_info?.includes('Móvil') ? '📱' : '💻'}
                      </div>
                      <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                          <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--color-text)' }}>
                            {s.browser || 'Navegador desconocido'}
                          </div>
                          {isCurrent && (
                            <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 999, background: 'rgba(34,197,94,0.15)', color: '#22c55e' }}>
                              {t('esta_sesion')}
                            </span>
                          )}
                        </div>
                          <div style={{ fontSize: 11, color: 'var(--color-muted)', marginTop: 2 }}>
                            {s.device_info} · {t('ultimo_acceso')} {timeAgo(s.last_seen)}
                          </div>
                        <div style={{ fontSize: 10, color: '#6b7280', marginTop: 1 }}>
                          Iniciada {timeAgo(s.created_at)}
                        </div>
                      </div>
                    </div>

                    {!isCurrent && (
                      <button
                        onClick={() => closeSession(s.session_token)}
                        style={{ fontSize: 12, padding: '8px 12px', borderRadius: 10, border: 'none', background: 'rgba(239,68,68,0.1)', color: '#ef4444', cursor: 'pointer', fontWeight: 600, flexShrink: 0, transition: '0.2s' }}
                        onMouseEnter={e => e.currentTarget.style.background = 'rgba(239,68,68,0.2)'}
                        onMouseLeave={e => e.currentTarget.style.background = 'rgba(239,68,68,0.1)'}
                      >
                        {t('cerrar')}
                      </button>
                    )}
                  </div>
                )
              })}

              {/* CERRAR TODAS LAS OTRAS */}
              {activeSessions.filter(s => s.session_token !== currentToken).length > 0 && (
                  <button
                  onClick={handleCloseAllOtherSessionsClick}
                  style={{ width: '100%', marginTop: 6, padding: '12px', borderRadius: 14, border: '1px solid rgba(239,68,68,0.25)', background: 'rgba(239,68,68,0.06)', color: '#ef4444', cursor: 'pointer', fontWeight: 700, fontSize: 13, transition: '0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.background = 'rgba(239,68,68,0.12)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'rgba(239,68,68,0.06)'}
                >
                  {t('cerrar_otras_sesiones')}
                </button>
              )}
            </>
          )}
        </section>

        {/* CAMBIAR CONTRASEÑA */}
        <section style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 24, padding: 22, marginBottom: 22 }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6, color: 'var(--color-text)' }}>{t('password_titulo')}</div>
          <div style={{ fontSize: 13, color: 'var(--color-muted)', marginBottom: 16, lineHeight: 1.5 }}>
            {t('password_desc_pre')} <strong>{email}</strong> {t('password_desc_post')}
          </div>
          <button
            onClick={async () => {
              const { error } = await supabase.auth.resetPasswordForEmail(email, {
                redirectTo: window.location.origin + '/reset-password'
              })
              if (error) {
                console.log('Error reset:', error)
                toast.error('Error al enviar el correo')
              } else {
                toast.success('Correo enviado. Revisa tu bandeja de entrada.')
              }
            }}
            style={{ padding: '12px 18px', borderRadius: 14, border: 'none', background: 'linear-gradient(135deg,#f59e0b,#d97706)', color: 'white', fontWeight: 700, cursor: 'pointer', fontSize: 14 }}
          >
            {t('enviar_enlace')}
          </button>
        </section>
        
        {/* CREADORES */}
        <button
          onClick={() => navigate('/creadores')}
          style={{
            width: '100%',
            padding: '16px',
            borderRadius: 18,
            border: '1px solid rgba(99,102,241,0.3)',
            background: 'linear-gradient(135deg, rgba(99,102,241,0.12), rgba(139,92,246,0.08))',
            color: 'var(--color-text)',
            fontWeight: 700,
            fontSize: 15,
            cursor: 'pointer',
            marginBottom: 14,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
            transition: '0.2s',
            position: 'relative',
            overflow: 'hidden'
          }}
          onMouseEnter={e => {
            e.currentTarget.style.borderColor = 'rgba(99,102,241,0.7)'
            e.currentTarget.style.background = 'linear-gradient(135deg, rgba(99,102,241,0.2), rgba(139,92,246,0.14))'
          }}
          onMouseLeave={e => {
            e.currentTarget.style.borderColor = 'rgba(99,102,241,0.3)'
            e.currentTarget.style.background = 'linear-gradient(135deg, rgba(99,102,241,0.12), rgba(139,92,246,0.08))'
          }}
        >
          <span style={{ fontSize: 20 }}>🧑‍💻</span>
          {t('creadores')}
          <span style={{ fontSize: 13, color: 'var(--color-muted)', fontWeight: 400 }}>→</span>
        </button>

        {/* ELIMINAR CUENTA */}
        <button
          onClick={() => navigate('/eliminar-cuenta')}
          style={{
            width: '100%',
            padding: '14px',
            borderRadius: 18,
            border: '1px solid rgba(239,68,68,0.3)',
            background: 'rgba(239,68,68,0.06)',
            color: '#ef4444',
            fontWeight: 700,
            fontSize: 14,
            cursor: 'pointer',
            marginBottom: 14,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            transition: '0.2s'
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(239,68,68,0.12)'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgba(239,68,68,0.06)'}
        >
          🗑️ {t('eliminar_cuenta_boton') || 'Eliminar mi cuenta'}
        </button>
        {/* GUARDAR */}
        <button
          onClick={handleSave}
          disabled={saving}
          style={{ width: '100%', padding: '16px', borderRadius: 18, border: 'none', background: saving ? '#166534' : 'linear-gradient(135deg, #22c55e, #16a34a)', color: 'white', fontWeight: 700, fontSize: 15, cursor: 'pointer', transition: '0.2s' }}
        >
          {saving ? t('guardando') : t('guardar')}
        </button>

</main>

      {/* MODAL CONFIRMAR CERRAR SESIONES */}
      {showConfirmCloseSessions && (
        <div style={{
          position: 'fixed', top: 0, left: 0,
          width: '100%', height: '100%',
          background: 'rgba(0,0,0,0.6)',
          display: 'flex', justifyContent: 'center', alignItems: 'center',
          zIndex: 200, padding: 16, boxSizing: 'border-box'
        }}>
          <div style={{
            background: '#111', padding: 24, borderRadius: 20,
            width: '100%', maxWidth: 320,
            display: 'flex', flexDirection: 'column', gap: 12,
            textAlign: 'center'
          }}>
            <div style={{ fontSize: 36 }}>🔒</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: 'white' }}>
            {t('modal_cerrar_sesiones_titulo')}
          </div>
          <div style={{ fontSize: 13, color: '#6b7280' }}>
            {t('modal_cerrar_sesiones_desc')}
          </div>
          <button
            onClick={closeAllOtherSessions}
            style={{
              padding: '12px', borderRadius: 10,
              background: '#ef4444', color: '#fff',
              border: 'none', cursor: 'pointer',
              fontWeight: 700, fontSize: 14
            }}
          >
            {t('modal_cerrar_sesiones_confirmar')}
          </button>
          <button
            onClick={() => setShowConfirmCloseSessions(false)}
            style={{
              padding: '12px', borderRadius: 10,
              background: '#333', color: '#fff',
              border: 'none', cursor: 'pointer', fontWeight: 600
            }}
          >
            {t('modal_cancelar')}
          </button>
          </div>
        </div>
      )}

      {/* MODAL CONFIRMAR GENERAR ID */}
      {showConfirmGenerateId && (
        <div style={{
          position: 'fixed', top: 0, left: 0,
          width: '100%', height: '100%',
          background: 'rgba(0,0,0,0.6)',
          display: 'flex', justifyContent: 'center', alignItems: 'center',
          zIndex: 200, padding: 16, boxSizing: 'border-box'
        }}>
          <div style={{
            background: '#111', padding: 24, borderRadius: 20,
            width: '100%', maxWidth: 320,
            display: 'flex', flexDirection: 'column', gap: 12,
            textAlign: 'center'
          }}>
            <div style={{ fontSize: 36 }}>🆔</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: 'white' }}>
              {friendId ? t('modal_generar_id_titulo_ya') : t('modal_generar_id_titulo_nuevo')}
            </div>
            <div style={{ fontSize: 13, color: '#6b7280' }}>
              {friendId
                ? t('modal_generar_id_desc_ya')
                : t('modal_generar_id_desc_nuevo')}
            </div>
            <button
              onClick={confirmarGenerateId}
              style={{
                padding: '12px', borderRadius: 10,
                background: '#3b82f6', color: '#fff',
                border: 'none', cursor: 'pointer',
                fontWeight: 700, fontSize: 14
              }}
            >
              {friendId ? t('modal_generar_id_confirmar_ya') : t('modal_generar_id_confirmar_nuevo')}
            </button>
            <button
              onClick={() => setShowConfirmGenerateId(false)}
              style={{
                padding: '12px', borderRadius: 10,
                background: '#333', color: '#fff',
                border: 'none', cursor: 'pointer', fontWeight: 600
              }}
            >
              {t('modal_cancelar')}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}